/**
 * Shared editable-form helpers for the Gag Breakdown editors (the gag detail
 * panel and the shared task editor). Extracted so the gag form and the task
 * form apply the SAME change-detection + date-normalisation rules and can't
 * drift apart.
 */

/**
 * Diff a form against its snapshot → payload of ONLY the changed fields.
 *
 * INVARIANT: both objects hold every value as a STRING (see the form
 * factories) — change detection is strict `!==`, the same comparison the
 * isDirty checks rely on. Any new field MUST be normalised to a string in its
 * form factory, or its edits are silently mis-detected here and in the dirty
 * guard.
 *
 * options.skip:       keys excluded from the diff (handled separately, e.g.
 *                     assignee_ids arrays).
 * options.trimFields: string fields trimmed in the outgoing payload.
 */
export function diffChangedFields(form, snapshot, { skip = [], trimFields = [] } = {}) {
  const payload = {};
  for (const k of Object.keys(form)) {
    if (skip.includes(k)) continue;
    if (form[k] !== snapshot[k]) payload[k] = form[k];
  }
  for (const f of trimFields) {
    if (f in payload) payload[f] = payload[f].trim();
  }
  return payload;
}

/** Normalise a date-ish value to a bare YYYY-MM-DD string (or '' when empty). */
export const dateOnly = (v) => (v ? String(v).slice(0, 10) : '');
